import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { heroImage } from '../mock';
import { useLang } from '../i18n/LanguageContext';

const Hero = () => {
  const { t } = useLang();
  return (
    <section className="relative h-screen min-h-[640px] w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url('${heroImage}')` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/55" />

      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 lg:px-10 flex flex-col justify-center">
        <h1
          className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold leading-[1.05] max-w-4xl"
          style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif", letterSpacing: '0.01em' }}
        >
          {t('hero.title1')}
          <br />
          {t('hero.title2')}
          <br />
          {t('hero.title3')}
        </h1>

        <Link
          to="/identita"
          className="mt-10 inline-flex items-center gap-3 self-start border border-white text-white px-7 py-3 tracking-[0.25em] text-sm font-semibold uppercase hover:bg-white hover:text-[#0b2545] transition-colors"
        >
          {t('hero.cta')} <ArrowRight size={16} />
        </Link>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/80 flex flex-col items-center animate-bounce">
        <span className="text-[10px] tracking-[0.3em] uppercase mb-1">{t('hero.scroll')}</span>
        <ChevronDown size={20} />
      </div>
    </section>
  );
};

export default Hero;
